import React, { Dispatch, SetStateAction } from 'react';

import * as S from './styles';
import { ISubjectContentData } from '../..';
import { LessonContent, ExamContent } from './components';
import { IExam } from '../../../../../../services/newStudent/myCourses/myCourses.service';
import {
  courseAssessmentContent,
  courseAuxiliaryContent,
  courseDisciplineContent,
} from '../../../../../../variables';
import { IClassInfo } from '../../../../../../pages/newStudent/MyCoursesNewStudent/components/Subjects';
import type { AssessmentDetail } from '../..';
import { isAcademicProjectKind } from '../../../../../../util/newStudent/academicProject';

interface Props {
  selected: string | number;
  subjectContent?: ISubjectContentData;
  subjectAuxiliaryContent?: ISubjectContentData;
  subjectExam?: IExam;
  setSubjectExam?: Dispatch<SetStateAction<IExam>>;
  setContentSelected: Dispatch<SetStateAction<string>>;
  setBlockedContent: Dispatch<SetStateAction<boolean>>;
  classInfo: IClassInfo;
  assessmentDetail: AssessmentDetail;
}
export default function ContentSelected({
  selected,
  subjectContent,
  subjectAuxiliaryContent,
  subjectExam,
  setSubjectExam,
  setContentSelected,
  setBlockedContent,
  classInfo,
  assessmentDetail,
}: Props) {
  const noContetSelected = () => {
    return (
      <S.Div>
        <S.H5>Nenhum item selecionado.</S.H5>
      </S.Div>
    );
  };

  function subjectLessonContent() {
    return subjectContent?.title || subjectContent?.url ? (
      <LessonContent data={subjectContent} classInfo={classInfo} />
    ) : (
      noContetSelected()
    );
  }

  function subjectLessonAuxiliaryContent() {
    return subjectAuxiliaryContent?.title || subjectAuxiliaryContent?.url ? (
      <LessonContent data={subjectAuxiliaryContent} classInfo={classInfo} />
    ) : (
      noContetSelected()
    );
  }

  function subjectFinalExamContent() {
    if (
      assessmentDetail === 'delivery' &&
      subjectContent &&
      isAcademicProjectKind(subjectContent.type) &&
      subjectContent.title
    ) {
      return <LessonContent data={subjectContent} classInfo={classInfo} />;
    }

    return subjectExam ? (
      <ExamContent
        data={subjectExam}
        setData={setSubjectExam}
        setContentSelected={setContentSelected}
        setBlockedContent={setBlockedContent}
      />
    ) : (
      noContetSelected()
    );
  }

  const contentSelected = {
    [+courseDisciplineContent!]: subjectLessonContent(),
    [+courseAuxiliaryContent!]: subjectLessonAuxiliaryContent(),
    [+courseAssessmentContent!]: subjectFinalExamContent(),
  };

  return <S.Container>{contentSelected[selected]}</S.Container>;
}
